// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job-allowance[data-v-5cc21752]{display:flex}.job-allowance__name[data-v-5cc21752]{flex-shrink:0;width:100px}.job-allowance__description[data-v-5cc21752]{white-space:pre-wrap;word-wrap:break-word}@media (min-width:960px){.job-allowance__name[data-v-5cc21752]{width:120px}}", ""]);
// Exports
module.exports = exports;
